import * as $ from "utils/jQueryShim";

// Not unit tested
$.onDocumentReady(() => {
	const bodyEl = document.querySelector("body")!;
	let touchEndTimeout: number | null = null;

	function enableHover() {
		bodyEl.classList.add("app-allow-hover");
	}

	function disableHover() {
		bodyEl.classList.remove("app-allow-hover");
	}

	function onTouchStart() {
		if (touchEndTimeout) {
			window.clearTimeout(touchEndTimeout);
		}
		bodyEl.removeEventListener("mousemove", enableHover);
		disableHover();
	}

	function onTouchEnd() {
		touchEndTimeout = window.setTimeout(function () {
			bodyEl.addEventListener("mousemove", enableHover);
		}, 100);
	}

	enableHover();
	bodyEl.addEventListener("touchstart", onTouchStart);
	bodyEl.addEventListener("touchend", onTouchEnd);
});
